
import React, { Fragment, useState, memo, useEffect } from 'react'
import { Dialog, Popover, Tab, Transition } from '@headlessui/react'
import { Bars3Icon, MagnifyingGlassIcon, ShoppingBagIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom';
import Logo from './../assist/triokzzlohgo.svg';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

const navigation = {
    categories: [
        {
            id: 'womens',
            name: 'Women',
            featured: [
                {
                    name: 'New Arrivals',
                    href: '/product/womens',
                    imageSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/1736439817241.webp",
                    imageAlt: 'Models sitting back to back, wearing Pithani in black and bone.',
                },
                {
                    name: 'Basic Tees',
                    href: '/product/womens',
                    imageSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/1739428818837.webp",
                    imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
                },
            ],
            sections: [
                {
                    id: 'clothing',
                    name: 'Clothing',
                    items: [
                        { name: 'Unisex Tshirt', href: '/product/womens' },
                        { name: 'Solid Tshirt', href: '/product/womens' }
                        // { name: 'Pants', href: '#' },
                        // { name: 'Denim', href: '#' },
                        // { name: 'Sweaters', href: '#' },
                        // { name: 'T-Shirts', href: '/product/womens' },
                        // { name: 'Jackets', href: '#' },
                        // { name: 'Activewear', href: '#' },
                        // { name: 'Browse All', href: '#' },
                    ],
                }
            ],
        },
        {
            id: 'mens',
            name: 'Men',
            featured: [
                {
                    name: 'New Arrivals',
                    href: '/product/mens',
                    imageSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/menwomen_teeshirts_unisex/Round-neck-model-JI-T-120-124.webp",
                    imageAlt: 'Drawstring top with elastic loop unisex tshirt',
                }
                // {
                //     name: 'Artwork Tees',
                //     href: '#',
                //     imageSrc: "https://rukminim2.flixcart.com/image/416/416/xif0q/wall-decoration/w/p/x/metal-wall-decor-wall-arts-for-home-living-room-hotel-decoration-original-imagqhzbtq8qhy4s.jpeg?q=70",
                //     imageAlt:
                //         'Three shirts in gray, white, and blue arranged on table with same line drawing of hands and shapes overlapping on front of shirt.',
                // },
            ],
            sections: [
                {
                    id: 'clothing',
                    name: 'Clothing',
                    items: [
                        // { name: 'Pants', href: '#' },
                        // { name: 'Sweaters', href: '#' },
                        { name: 'T-Shirts', href: '/product/mens' },
                        { name: 'Solid T-shirts', href: '/product/mens' },
                        // { name: 'Activewear', href: '#' },
                        // { name: 'Browse All', href: '#' },
                    ],
                },
                {
                    id: 'accessories',
                    name: 'Accessories',
                    items: [
                        // { name: 'Watches', href: '#' },
                        // { name: 'Wallets', href: '#' },
                        { name: 'Bags', href: '/product/travelling' },
                        // { name: 'Sunglasses', href: '#' },
                        // { name: 'Hats', href: '#' },
                        // { name: 'Belts', href: '#' },
                    ],
                },
                {
                    id: 'brands',
                    name: 'Brands',
                    items: [
                        { name: 'Re-Arranged', href: '#' },
                        { name: 'Counterfeit', href: '#' },
                        { name: 'Full Nelson', href: '#' },
                        { name: 'My Way', href: '#' },
                    ],
                },
            ],
        },
        {
            id: 'home decor',
            name: 'Home Decor',
            featured: [
                {
                    name: 'New Arrivals',
                    href: '/product/decor',
                    imageSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/1726226527676.webp",
                    imageAlt: 'ghungru kadi.',
                },
                {
                    name: 'Basic Tees',
                    href: '/product/decor',
                    imageSrc: "https://rukminim2.flixcart.com/image/416/416/xif0q/wall-decoration/w/p/x/metal-wall-decor-wall-arts-for-home-living-room-hotel-decoration-original-imagqhzbtq8qhy4s.jpeg?q=70",
                    imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
                },
            ],
            sections: [
                {
                    id: 'decore',
                    name: 'decor',
                    items: [
                        { name: 'Shisha pot', href: '/product/decor' },
                        { name: 'copper glass', href: '/product/decor' },
                        { name: 'coco bowl', href: '/product/decor' },
                        { name: 'drawing', href: '/product/decor' },
                        { name: 'painting', href: '/product/personalized-gifts' }
                    ],
                }
            ],
        }
    ],
    pages: [
        { name: 'Company', href: '#' },
        { name: 'Stores', href: '#' },
    ],
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const confirmAction = () => {
    const t = toast.custom((t) => (
      <div style={{
        padding: '16px',
        color: 'white',
        background: '#363636',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}>
        <span>Are you sure you want to Logout🙃?</span>
        <button
          onClick={() => {
            // Handle 'Yes' action
            localStorage.clear()
            toast.dismiss(t.id); // Dismiss the toast
          }}
          style={{
            padding: '8px 12px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Yes
        </button>
        <button
          onClick={() => {
            // Handle 'No' action (optional)
            toast.dismiss(t.id); // Dismiss the toast
          }}
          style={{
            padding: '8px 12px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          No
        </button>
      </div>
    ), {
      duration: Infinity, // Keep the toast visible until a button is clicked
    });
  };

export default function ProductNav(props) {
    const [open, setOpen] = useState(false)
    const [searchinput, setSearchinput] = useState("")
    // const [dropdownsearch, setdropdownsearch] = useState("")
    // let session = JSON.parse(localStorage.getItem('PHONEOTPINFO'))
                const [session, setSession] = useState(null);
            
            useEffect(() => {
              const stored = localStorage.getItem('PHONEOTPINFO');
              if (stored) {
                setSession(JSON.parse(stored));
              }
            }, []);
    const navigate = useNavigate()

    const onSearchinput = (val) => {
        setSearchinput(val)
    }
    // const onDropdownsearch = (val)=>{
    //     setdropdownsearch(val)
    // }

    useEffect(() => {
        if (searchinput.length > 3) {
            // toast("Please select the category first")
            props.onfilter(searchinput)
   
        }
        //  else {
        //     // setSearchinput("")
        //     props.onfilter(undefined)
        // }
    }, [searchinput]);
    return (
        <div className="sticky top-0 z-20 bg-white" role="navigation">
            {/* Mobile menu */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-40 flex">
                        <Transition.Child
                            as={Fragment}
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                                <div className="flex px-4 pb-2 pt-5">
                                    <button
                                        type="button"
                                        className="relative -m-2 inline-flex items-center justify-center bg-red rounded-md p-2 text-gray-400"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Modernize Ayurvedic skincare, inspire positivity in people</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>

                                <Tab.Group as="div" className="mt-2">
                                    <div className="border-b border-gray-200">
                                        <Tab.List className="-mb-px space-x-8 px-4">
                                            {navigation.categories.map((category) => (
                                                <Tab
                                                    key={category.name}
                                                    className={({ selected }) =>
                                                        classNames(
                                                            selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-900',
                                                            'flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium'
                                                        )
                                                    }
                                                    onClick={() => props.onSelectNavItem(category.id)}
                                                >
                                                    {category.name}
                                                </Tab>
                                            ))}
                                        </Tab.List>
                                    </div>
                                    <Tab.Panels as={Fragment}>
                                        {navigation.categories.map((category) => (
                                            <Tab.Panel key={category.name} className="space-y-10 px-4 pb-8 pt-10">
                                                <div className="grid grid-cols-2 gap-x-4">
                                                    {category.featured.map((item) => (
                                                        <div key={item.name} className="group relative text-sm">
                                                            <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                                                <img src={item.imageSrc} alt="Handwoven Elegance for the Modern Women" className="object-cover object-center" width="100%" height="100%" />
                                                            </div>
                                                            <a href={item.href} className="mt-6 block font-medium text-gray-900">
                                                                <span className="absolute inset-0 z-10" aria-hidden="true" />
                                                                {item.name}
                                                            </a>
                                                            <p aria-hidden="true" className="mt-1">
                                                                Shop now
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                                {category.sections.map((section) => (
                                                    <div key={section.name}>
                                                        <p id={`${category.id}-${section.id}-heading-mobile`} className="font-medium text-gray-900">
                                                            {section.name}
                                                        </p>
                                                        <ul
                                                            role="list"
                                                            aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                                                            className="mt-6 flex flex-col space-y-6"
                                                        >
                                                            {section.items.map((item) => (
                                                                <li key={item.name} className="flow-root">
                                                                    <a href={item.href} className="-m-2 block p-2 text-gray-500">
                                                                        {item.name}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </Tab.Panel>
                                        ))}
                                    </Tab.Panels>
                                </Tab.Group>
                                <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                                    <div className="flow-root">
                                        <ul className="items-center mb-6 text-sm font-medium text-gray-900 sm:mb-0 dark:text-black">
                                            <li className="mr-4 hover:underline md:mr-6 ">
                                                <a href="/grocery/products"> Grocery</a>
                                            </li>
                                            <li className="mr-4 hover:underline md:mr-6 ">
                                                <a href="/watchtv"> WatchTv</a>
                                            </li>

                                            <li className="mr-4 hover:underline md:mr-6 ">
                                                <a href="/product/decor">Home and temple Decor</a>
                                            </li>
                                            <li className="mr-4 hover:underline md:mr-6 ">
                                                <a href="/about">
                                                    About
                                                </a>
                                            </li>
                                            <li className="mr-4 hover:underline md:mr-6">
                                                <a href="/privacy">
                                                    Privacy
                                                </a>
                                            </li>
                                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/contact")}>
                                                Contact
                                            </li>
                                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => confirmAction()}>
                                            LogOut
                                        </li>
                                        </ul>
                                    </div>
                                    {/* <div className="flow-root">
                                        <a href="#" className="-m-2 block p-2 font-medium text-gray-900">
                                            Create account
                                        </a>
                                    </div> */}
                                </div>

                                <div className="border-t border-gray-200 px-4 py-6">
                                    <a href="#" className="-m-2 flex items-center p-2">
                                    <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                             
                                        <span className="ml-3 block text-base font-medium text-gray-900">IND</span>
                                        <span className="sr-only">Traditional decor collection</span>
                                    </a>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>

            <header className="relative bg-white-50 text-gray-900">
                {/* <div className="ml-4 flex lg:ml-0">
                    <a href="/">
                        <span className="sr-only">Shopify</span>
                        <img
                            className="h-8 w-auto"
                            // src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                            alt="Shopify"
                        />
                    </a>
                </div> */}
                {/* <p className="flex h-10 items-center justify-center bg-indigo-600 px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
                    All  product price are tax included
                </p> */}

                <nav aria-label="Top" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-5">
                    <div className="border-b border-gray-200">
                        <div className="flex h-10 items-center">
                            <button
                                type="button"
                                className="relative rounded-md bg-white p-1 text-gray-400 lg:hidden"
                                onClick={() => setOpen(true)}
                            >
                                <span className="absolute -inset-0.5" />
                                <span className="sr-only">Open menu</span>
                                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                            </button>

                            {/* Logo */}
                            <div className="ml-1 flex lg:ml-0">
                                {/* <a href="/"> */}
                                <span className="sr-only">Triokzz</span>
                                <img
                                    // className="h-12 w-36"
                                    src={Logo}
                                    alt="Triokzz logo"
                                    width="120px" height="100%"
                                />
                                {/* </a> */}
                            </div>

                            <div className="ml-auto flex items-center">
                                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                                    {/* <a href="/login" className="text-sm font-medium text-gray-700 hover:text-gray-800"> */}
                                    <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-900 sm:mb-0 dark:text-black">

                                        <li className="mr-4 hover:underline md:mr-6 ">
                                            <a href="/product/printed"> Gift Hub</a>
                                        </li>

                                        <li className="mr-4 hover:underline md:mr-6 ">
                                            <a href="/product/decor">Home and temple Decor</a>
                                        </li>
                                        <li className="mr-4 hover:underline md:mr-6 ">
                                            <a href="/about">
                                                About
                                            </a>
                                        </li>
                                        <li className="mr-4 hover:underline md:mr-6">
                                            <a href="/privacy">
                                                Privacy
                                            </a>
                                        </li>
                                        <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/contact")}>
                                            Contact
                                        </li>
                                        <li className="mr-4 hover:underline md:mr-6 " onClick={() => confirmAction()}>
                                            LogOut
                                        </li>
                                    </ul>
                                    {/* </a> */}
                                    {/* <span className="h-6 w-px bg-gray-200" aria-hidden="true" /> */}
                                </div>

                               

                                {/* Search */}
                                {/* <div className=" lg:ml-6"> */}
                                <div className="flex items-center min-h-0l float-right">
                                    <label htmlFor="simple-search" className="sr-only">Search</label>

                                    <div className="relative w-full">
                                        <input type="text"
                                            id="simple-search"
                                            value={searchinput}
                                            onChange={(e) => onSearchinput(e.target.value)}
                                            className="w-36 border-2 border-violet-200"
                                             placeholder="Search sarees," />
                                    </div>
                                    {/* <select id="pricingType" name="pricingType" onChange={(e) => onDropdownsearch(e.target.value)}
                                        className="w-1/2 h-8 border-1 border-sky-500 capitalize truncate focus:outline-none focus:border-sky-500 text-sky-500 rounded px-2 md:px-3 py-0 md:py-1 tracking-wider">

                                        {props.menuItems && props.menuItems.products && props.menuItems.products.map((val, i) => <option value={val && val.product_for} className="capitalize truncate" key={i}>{val && val.product_for}</option>)}

                                    </select> */}
                                    {/* <button onClick={() => {
                                        // setTimeout(() => {
                                        props.onfilter(searchinput, dropdownsearch)
                                        // }, 2000)
                                    }} className="p-1 ml-1 text-sm font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                        <span className="sr-only">Search</span>
                                    </button> */}
                                </div>

                                {/* </div> */}

                                {/* Cart */}
                                {/* <div className="ml-2 flow-root lg:ml-4" onClick={()=>{ if(session && session.phoneNumber){
                                    toast(`${session && session.phoneNumber} already verified`)
                                }else{props.setShowChild(true)}}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div> */}
                                      {/* Cart */}
            <button
            onClick={() => props && props.onshoppingRender()}
              className="relative flex items-center gap-1.5 bg-violet-700 hover:bg-violet-800 text-white px-4 py-2 rounded-xl transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span className="text-sm font-bold">Cart</span>
              <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-[10px] font-black w-5 h-5 rounded-full flex items-center justify-center">{props && props.selectedItem}</span>
            </button>
                                {/* <div className="ml-2 flow-root lg:ml-4" onClick={() => props && props.onshoppingRender()}>
                                    <div className="group -m-2 flex items-center p-2">
                                     

                                        <span className="ml-2 w-5 animate-pulse rounded-full border-1 animate-bounce text-xl font-semibold  text-red-700 group-hover:text-green-800">{props && props.selectedItem}</span>
                                        <span className="sr-only">Your wishlist our deal</span>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                    </div>
                </nav>
            </header>
        </div>
    )
}
